import { SelectOptionType } from '@bp/ui-components';
import { Frequency, Options, RRule, RRuleSet } from 'rrule';

export function buildRRule({
  start,
  recurrence,
  weekdays,
  interval,
  repeatUntil,
}: {
  start: Date | null;
  repeatUntil: Date | null;
  recurrence?: SelectOptionType | null;
  weekdays?: SelectOptionType[] | null;
  interval?: number;
}): RRuleSet | null {
  if (!start || !recurrence) {
    return null;
  }

  const rruleSet = new RRuleSet();

  const options: Partial<Options> = {
    dtstart: start,
    tzid: 'UTC',
    interval: interval || 1,
    freq: recurrence.value as Frequency,
  };

  if (weekdays && weekdays.length > 0 && recurrence.value === RRule.WEEKLY) {
    options.byweekday = weekdays.map((w) => w.value) as number[];
  }

  if (repeatUntil) {
    // "Letzte Wiederholung" ist ein Kalendertag – UNTIL ist inklusiv, darf aber nicht vor der Uhrzeit des Termins liegen
    const until = new Date(repeatUntil);
    until.setHours(23, 59, 59, 999);
    options.until = until;
  }

  options.count = 1000;

  rruleSet.rrule(new RRule(options));

  return rruleSet;
}
